import React from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import EnhancedTable from '../../components/table';

import { cleanSearch } from '../../libraries/utils';

const FormList = mapHooksToProps => {
  const { title, service, name } = mapHooksToProps;
  return props => {
    const { classes } = props;

    let {
      location: { search }
    } = props;
    search = cleanSearch(search);
    return (
      <Card className={classes.card}>
        <CardHeader title={title} />
        <CardContent className={classes.cardContent}>
          <EnhancedTable service={service} search={search} name={name} {...props} />
        </CardContent>
      </Card>
    );
  };
};

export default FormList;
